export default __webpack_public_path__ + "static/media/logo-transparent-high-res.59f90b3d.png";